export { default } from '@default/themes/kultour/components/template/footer'
